import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TablePurchaseOrder from "./components/tables/TablePurchaseOrder";

function PurchasePurchaseOrderRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TablePurchaseOrder />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PurchasePurchaseOrderRegister;